import React, { useEffect, useState, useContext } from "react";
import { Modal, Table } from "react-bootstrap";
import { Context } from "../../../utils/context";

const VendorDesignModal = ({ show, handleClose, vendorId }) => {
  const { getData, IMG_URL } = useContext(Context);

  const [designs, setDesigns] = useState({});

  const getVendorDesigns = async () => {
    if (!vendorId) return;

    const response = await getData(`/admin/vendor/design/${vendorId}`);

    if (response?.success) {
      setDesigns(response?.data || {});
    }
  };

  useEffect(() => {
    if (show) {
      getVendorDesigns();
    }
  }, [show, vendorId]);

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Vendor Designs</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {designs?.id ? (
          <Table bordered responsive hover>
            <thead>
              <tr>
                <th>Design Name</th>
                <th>Vendor Design Price</th>
                <th>Express Delivery Price</th>
                <th>Processing Days</th>
                <th>Express Delivery Days</th>
                <th>Express Delivery Hour</th>
                <th>Vendor Name</th>
                <th>Vendor Contact No</th>
                <th>Patent Status</th>
                 <th>Customize Status</th>
              </tr>
            </thead>

            <tbody>
              <tr key={designs?.id}>
                <td>{designs?.Design?.name || "N/A"}</td>

                <td>₹ {designs?.price || "N/A"}</td>

                <td>₹ {designs?.express_delivery_price || "N/A"}</td>
                <td>{designs?.order_time || "N/A"}</td>
                <td>{designs?.express_delivery_days || "N/A"}</td>
                <td>{designs?.express_delivery_time || "N/A"}</td>
                <td>{designs?.User?.name || "N/A"}</td>

                <td>{designs?.User?.contact_no || "N/A"}</td>
                <td>
                  {designs?.Design?.patent_status ? "Yes" : "No" || "N/A"}
                </td>
                 <td>
                  {designs?.Design?.customization_status ? "Yes" : "No" || "N/A"}
                </td>
              </tr>
            </tbody>
          </Table>
        ) : (
          <div className="text-center">No Designs Found</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default VendorDesignModal;
